import { call } from "../dashboard/service";
import billingConstants from "./billingConstants";

export default {
  namespaced: true,
  state: {
    receipt: null,
    invoice: null,
    invoiceMetadata: null,
    billingAddresses: "",
  },
  mutations: {
    SET_RECEIPT: (state, payload) => {
      state.receipt = payload;
    },

    SET_INVOICE: (state, payload) => {
      state.invoice = payload;
    },

    SET_INVOICE_METADATA: (state, payload) => {
      state.invoiceMetadata = payload;
    },

    SET_BILLING_ADDRESSES: (state, payload) => {
      state.billingAddresses = payload;
    },
  },
  getters: {
    receipt: (state) => state.receipt,
    invoice: (state) => state.invoice,
    billingAddresses: (state) => state.billingAddresses,
    invoiceMetadata: (state) => state.invoiceMetadata,
  },
  actions: {
    getBillingAddresses: ({ commit }) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", billingConstants.billingAddresses)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("SET_BILLING_ADDRESSES", res.data.data);
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },

    createBillingAddress: ({ commit, dispatch }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", billingConstants.billingAddresses, data)
        .then(() => {
          dispatch("getBillingAddresses");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },

    saveBillingAddress: ({ commit, dispatch }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("patch", billingConstants.billingAddresses, data)
        .then(() => {
          dispatch("getBillingAddresses");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },

    removeBillingAddress: ({ commit, dispatch }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("delete", billingConstants.removeBillingAddresses(), data)
        .then(() => {
          dispatch("getBillingAddresses");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },

    getInvoice: ({ commit }, code) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", billingConstants.invoice(code))
        .then((res) => {
          commit(
            "SET_INVOICE",
            process.env.VUE_APP_TEMP_URL + res.data.data[0],
          );
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },

    getReceipt: ({ commit }, code) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", billingConstants.receipt(code))
        .then((res) => {
          commit(
            "SET_RECEIPT",
            process.env.VUE_APP_TEMP_URL + res.data.data[0],
          );
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
  },
};
